<template>
    <div class="inner-page" ref="page">
        <div class="heads">
            <img src="../../assets/mzzgHeadBack.jpg">
            <h1>民族之歌</h1>
        </div>
        <div class="mainBox">
             <a href="http://wap.china1904.com/wx/mzSong?iab=ba00f82b81d6714c0181d67b402f0fe2&icd=ba00f82b81d6714c0181d67c91ce1243">
                <img src="../../assets/mzzg1.jpg">
             </a>
             <a href="http://wap.china1904.com/wx/mzSong?iab=ba00f82b81d6714c0181d67c9e75125e&icd=ba00f82b81d6714c0181d67e540614f4">
                 <img src="../../assets/mzzg2.jpg">
             </a>
            <a href="http://wap.china1904.com/wx/mzSong?iab=ba00f82b81d6714c0181d67e61821508&icd=ba00f82b81d6714c0181d680a067176c">
                <img src="../../assets/mzzg3.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/mzSong?iab=ba00f82b81d6714c0181d680a9aa177c&icd=ba00f82b81d6714c0181d6813b7a186e">
                <img src="../../assets/mzzg4.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/mzSong?iab=ba00f82b81d6714c0181d6814464187f&icd=ba00f82b81d6714c0181d681506d1892">
                <img src="../../assets/mzzg5.jpg">
            </a>

        </div>
        <div class="foots">
            <img src="../../assets/mzzgBotBack.jpg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "hsjd"
    }
</script>

<style scoped lang="scss">

    .inner-page{
        background-color: #EDE5D5;
        .heads{
            width: 100%;
            height: 100%;
            position: relative;
            img{
                width: 100%;
            }
            h1{
                position: absolute;
                left: 50%;
                top: 35%;
                transform: translate(-50%,-50%);
                font-size: 24px;
                letter-spacing: 5px;
            }
        }
        .mainBox{
            width: auto;
            height: 100%;
            overflow-y: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            padding:  20px 10px;
            margin-bottom: 64px;
            a{
                display: block;
                overflow-y: hidden;
                width: 165px;
                padding: 0 6px;

            }
            img{
                width:100%;
                float: left;
                margin-bottom: 20px;
            }
        }
        .foots{
            position: fixed;
            bottom: -3px;
            left: 0;
        }

    }

</style>
